import { ResolveResource } from './utils'
import Factory from './utils/Factory'
const resource = ResolveResource(__filename)

export default new Factory(resource, {
  setTags(tags, leadId) {
    const url = new URL(`/api/lead/${leadId}/tags`, location.origin)
    if (tags.length) url.searchParams.append('tags', tags)
    else url.searchParams.append('reset', true)

    return fetch(url.toString(), { method: 'POST' })
  },
})
